import React, { useEffect, useState } from "react";
import api from "../../api";
import Loader from "../../components/Loader";

function Settings() {
    const [profile, setProfile] = useState({ name: "", email: "", phone: "" });
    const [businessdata, setbusinessdata] = useState({ business_name: "", address: "", latitude: "", longitude: "" , name: "" , email: "" , phone: "" , about_business: "" , logo: null});

    const [passwordForm, setPasswordForm] = useState({
        currentPassword: "",
        newPassword: "",
        confirmPassword: "",
    });
    const [loading, setLoading] = useState(true);
    const [success, setSuccess] = useState("");
    const [error, setError] = useState("");
    const [activeTab, setActiveTab] = useState("profile");

    useEffect(() => {
        fetchProfile();
        fetchBusinessDetails();
    }, []);

    // Auto-hide alerts after 4 seconds
    useEffect(() => {
        if (success || error) {
            const timer = setTimeout(() => {
                setSuccess("");
                setError("");
            }, 4000);
            return () => clearTimeout(timer);
        }
    }, [success, error]);

    const fetchProfile = async () => {
        try {
            setLoading(true);
            const res = await api.get("/profile");
            setProfile(res.data);

            if (res.data.id) {
                fetchBusinessDetails(res.data.id);
            }

        } catch (err) {
            console.error(err.response || err.message);
            setError("Failed to fetch profile");
        } finally {
            setLoading(false);
        }
    };

    const fetchBusinessDetails = async (userId) => {
        try {
            setLoading(true);
            const res = await api.get(`/business-details/${userId}`);

            setbusinessdata(prev => ({
                ...prev,
                ...res.data.data
            }));
        } catch (err) {
            console.error(err.response || err.message);
            setError("Failed to fetch business details");
        } finally {
            setLoading(false);
        }
    };



    const updateProfile = async (e) => {
        e.preventDefault();
        setError(""); setSuccess("");
        try {
            setLoading(true);
            await api.put("/profile", profile);
            setSuccess("Profile updated successfully");
        } catch (err) {
            console.error(err.response || err.message);
            setError(err.response?.data?.message || "Update failed");
        } finally { setLoading(false); }
    };


    const businessProfile = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");
        try {
            setLoading(true);
            const formData = new FormData();
            formData.append("id", businessdata.id);
            formData.append("name", businessdata.name);
            formData.append("email", businessdata.email);
            formData.append("phone", businessdata.phone);
            formData.append("business_name", businessdata.business_name);
            formData.append("about_business", businessdata.about_business);
            formData.append("address", businessdata.address);
            formData.append("latitude", businessdata.latitude);
            formData.append("longitude", businessdata.longitude);
            if (businessdata.logo) {
                formData.append("logo", businessdata.logo); 
            }
            await api.post("/business-profile", formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });
            setSuccess("Business Profile updated successfully");
        } catch (err) {
            console.error(err.response || err.message);
            setError(err.response?.data?.message || "Update failed");
        } finally {
            setLoading(false);
        }
    };


    const updatePassword = async (e) => {
        e.preventDefault();
        setError(""); setSuccess("");

        if (passwordForm.newPassword !== passwordForm.confirmPassword) {
            setError("New password and confirm password do not match");
            return;
        }

        try {
            setLoading(true);
            await api.put("/profile", {
                ...profile,
                currentPassword: passwordForm.currentPassword,
                newPassword: passwordForm.newPassword,
            });
            setPasswordForm({ currentPassword: "", newPassword: "", confirmPassword: "" });
            setSuccess("Password updated successfully");
        } catch (err) {
            console.error(err.response || err.message);
            setError(err.response?.data?.message || "Password update failed");
        } finally { setLoading(false); }
    };

    if (loading) return <Loader />;

    return (
        <div className="flex p-6 gap-8">
            {/* Sidebar */}
            <div className="w-60 bg-white shadow rounded-2xl p-6 flex flex-col space-y-4">
                <h2 className="text-lg font-bold mb-4">Settings</h2>
                <button
                    className={`text-left px-3 py-2 rounded ${activeTab === "profile" ? "bg-blue-100 font-semibold" : "hover:bg-gray-100"}`}
                    onClick={() => setActiveTab("profile")}
                >
                    Profile Setting
                </button>



                <button
                    className={`text-left px-3 py-2 rounded ${activeTab === "system" ? "bg-blue-100 font-semibold" : "hover:bg-gray-100"}`}
                    onClick={() => setActiveTab("system")}
                >
                    Business Setting
                </button>
                {/* <button
                    className={`text-left px-3 py-2 rounded ${activeTab === "security" ? "bg-blue-100 font-semibold" : "hover:bg-gray-100"}`}
                    onClick={() => setActiveTab("security")}
                >
                    Security Setting
                </button> */}
                <button
                    className={`text-left px-3 py-2 rounded ${activeTab === "password" ? "bg-blue-100 font-semibold" : "hover:bg-gray-100"}`}
                    onClick={() => setActiveTab("password")}
                >
                    Change Password
                </button>
            </div>

            {/* Content */}
            <div className="flex-1 space-y-8">
                {/* Alerts */}
                {success && (
                    <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded relative">
                        {success}
                    </div>
                )}
                {error && (
                    <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative">
                        {error}
                    </div>
                )}

                {activeTab === "profile" && (
                    <div className="bg-white shadow rounded-2xl p-6">
                        <h2 className="text-lg font-semibold mb-4">Profile Settings</h2>

                        {businessdata.logo && (                       
                            <img
                                src={`https://zarvika.meshink.xyz/backend/storage/app/public/${businessdata.logo}`}
                                alt="Business Logo"
                                width="120"
                            />                         
                        )}
                        
                        <form onSubmit={updateProfile} className="space-y-4">
                            <input
                                type="text"
                                value={profile.name}
                                onChange={e => setProfile({ ...profile, name: e.target.value })}
                                placeholder="Name"
                                className="w-full border rounded px-3 py-2"
                                required
                            />
                            <input
                                type="email"
                                value={profile.email}
                                onChange={e => setProfile({ ...profile, email: e.target.value })}
                                placeholder="Email"
                                className="w-full border rounded px-3 py-2"
                                required readOnly
                            />
                            <input
                                type="text"
                                value={profile.phone}
                                onChange={e => setProfile({ ...profile, phone: e.target.value })}
                                placeholder="Phone"
                                className="w-full border rounded px-3 py-2"
                            />
                            <button type="submit" className="bg-blue-600 text-white px-6 py-2 rounded">
                                Update Profile
                            </button>
                        </form>
                    </div>
                )}


                {activeTab === "system" && (
                    <div className="bg-white shadow rounded-2xl p-6">
                        <h2 className="text-lg font-semibold mb-6">Business Details</h2>

                        <form onSubmit={businessProfile} className="grid grid-cols-1 md:grid-cols-2 gap-4">

                            {/* Name */}
                            <div>
                                <label className="text-sm font-medium">Name</label>
                                <input
                                    type="text"
                                    value={businessdata.name}
                                    onChange={e => setbusinessdata({ ...businessdata, name: e.target.value })}
                                    className="w-full mt-1 border rounded-xl px-3 py-2"
                                    required
                                />
                            </div>

                            {/* Email */}
                            <div>
                                <label className="text-sm font-medium">Email</label>
                                <input
                                    type="email"
                                    value={businessdata.email}
                                    onChange={e => setbusinessdata({ ...businessdata, email: e.target.value })}
                                    className="w-full mt-1 border rounded-xl px-3 py-2"
                                    required readOnly
                                />
                            </div>

                            {/* Mobile */}
                            <div>
                                <label className="text-sm font-medium">Mobile</label>
                                <input
                                    type="text"
                                    value={businessdata.phone}
                                    onChange={e => setbusinessdata({ ...businessdata, phone: e.target.value })}
                                    className="w-full mt-1 border rounded-xl px-3 py-2"
                                />
                            </div>

                            {/* Business Name */}
                            <div>
                                <label className="text-sm font-medium">Business Name</label>
                                <input
                                    type="text"
                                    value={businessdata.business_name}
                                    onChange={e => setbusinessdata({ ...businessdata, business_name: e.target.value })}
                                    className="w-full mt-1 border rounded-xl px-3 py-2"
                                />
                            </div>

                            {/* Address (Full width) */}
                            <div className="md:col-span-2">
                                <label className="text-sm font-medium">Address</label>
                                <textarea
                                    value={businessdata.address}
                                    onChange={e => setbusinessdata({ ...businessdata, address: e.target.value })}
                                    className="w-full mt-1 border rounded-xl px-3 py-2"
                                    rows="2"
                                ></textarea>
                            </div>


                            {/* about business */}
                            <div className="md:col-span-2">
                                <label className="text-sm font-medium">About Business</label>
                                <textarea
                                    value={businessdata.about_business}
                                    onChange={e => setbusinessdata({ ...businessdata, about_business: e.target.value })}
                                    className="w-full mt-1 border rounded-xl px-3 py-2"
                                    rows="2"
                                ></textarea>
                            </div>

                            {/* logo*/}
                           <div className="md:col-span-2">
                                <label className="text-sm font-medium">Business logo</label>
                               <input
                                    type="file"
                                    onChange={(e) =>
                                        setbusinessdata({
                                            ...businessdata,
                                            logo: e.target.files[0], 
                                        })
                                    }
                                    className="w-full mt-1 border rounded-xl px-3 py-2"
                                    accept="image/png, image/jpg, image/jpeg"
                                />

                            </div>



                            {/* Latitude */}
                            <div>
                                <label className="text-sm font-medium">Latitude</label>
                                <input
                                    type="text"
                                    value={businessdata.latitude}
                                    onChange={e => setbusinessdata({ ...businessdata, latitude: e.target.value })}
                                    className="w-full mt-1 border rounded-xl px-3 py-2"
                                />
                            </div>

                            {/* Longitude */}
                            <div>
                                <label className="text-sm font-medium">Longitude</label>
                                <input
                                    type="text"
                                    value={businessdata.longitude}
                                    onChange={e => setbusinessdata({ ...businessdata, longitude: e.target.value })}
                                    className="w-full mt-1 border rounded-xl px-3 py-2"
                                />
                            </div>

                                <input
                                    type="hidden"
                                    value={businessdata.id}
                                    onChange={e => setbusinessdata({ ...businessdata, id: e.target.value })}
                                    className="w-full mt-1 border rounded-xl px-3 py-2"
                                />


                            {/* Submit */}
                            <div className="md:col-span-2 mt-4">
                                <button
                                    type="submit"
                                    className="w-full bg-purple-600 hover:bg-purple-700 text-white py-3 rounded-xl font-semibold"
                                >
                                    Save Changes
                                </button>
                            </div>

                        </form>
                    </div>
                )}

                {activeTab === "password" && (
                    <div className="bg-white shadow rounded-2xl p-6">
                        <h2 className="text-lg font-semibold mb-4">Change Password</h2>
                        <form onSubmit={updatePassword} className="space-y-4">
                            <input
                                type="password"
                                value={passwordForm.currentPassword}
                                onChange={e => setPasswordForm({ ...passwordForm, currentPassword: e.target.value })}
                                placeholder="Current Password"
                                className="w-full border rounded px-3 py-2"
                            />
                            <input
                                type="password"
                                value={passwordForm.newPassword}
                                onChange={e => setPasswordForm({ ...passwordForm, newPassword: e.target.value })}
                                placeholder="New Password"
                                className="w-full border rounded px-3 py-2"
                            />
                            <input
                                type="password"
                                value={passwordForm.confirmPassword}
                                onChange={e => setPasswordForm({ ...passwordForm, confirmPassword: e.target.value })}
                                placeholder="Confirm New Password"
                                className="w-full border rounded px-3 py-2"
                            />
                            <button type="submit" className="bg-blue-600 text-white px-6 py-2 rounded">
                                Change Password
                            </button>
                        </form>
                    </div>
                )}
            </div>
        </div>
    );
}

export default Settings;